import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { updateCustomerBusinessInfo } from "../../../../redux/slice/customer/customerSlice";

const BusinessInformation = ({ data, data1 }) => {
  const [editing, setEditing] = useState(false);
  const [editCustomer, setEditCustomer] = useState();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch();

  const handleClose = () => {
    values.business_address = data?.business_address;
    values.occupation = data?.occupation;
  };

  const onSubmit = (values) => {
    let payload = { ...values, id: data.id };
    dispatch(updateCustomerBusinessInfo(payload));
  };

  const validationScehma = Yup.object().shape({
    occupation: Yup.string("Staff Id must be a string").required(
      "Occupation cannot be blank"
    ),
    business_address: Yup.string("First Name must be a string").required(
      "Date of Issuance cannot be blank"
    ),
  });
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        business_address: data?.business_address || "",
        occupation: data?.occupation || "",
      },
      validationSchema: validationScehma,
      onSubmit,
    });

  useEffect(() => {
    setEditCustomer(
      user_permissions?.some(
        (permission) => permission.name === "edit customer - individual"
      )
    );
  }, [user_permissions]);
  return (
    <>
      <form
        className='border p-3 rounded-3 mt-4 position-relative'
        onSubmit={handleSubmit}
      >
        <h4 className='fw-semibold text-primary-1 bg-white position-absolute profile-title'>
          Business Information
        </h4>
        <div className='row'>
          <div className='col-md-12 row'>
            <div className='col-sm-6 col-md-4'>
              <label htmlFor='firstName ' className='fw-bold pb-1'>
                OCCUPATION
              </label>
              {!editing ? (
                <p className='text-capitalize'>{data?.occupation}</p>
              ) : (
                <div>
                  <input
                    className='form-control form-control-sm'
                    id='occupation'
                    value={values.occupation}
                    type='text'
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors?.occupation && touched?.occupation && (
                    <p className='mb-0 text-danger'>
                      {errors?.occupation + "*"}
                    </p>
                  )}
                </div>
              )}
            </div>
            <div className='col-sm-6 col-md-8'>
              <label htmlFor='lastname' className='fw-bold pb-1'>
                BUSINESS ADDRESS
              </label>
              {!editing ? (
                <p>{data?.business_address}</p>
              ) : (
                <div>
                  <textarea
                    className='form-control form-control-sm'
                    id='business_address'
                    value={values.business_address}
                    type='text'
                    onChange={handleChange}
                    onBlur={handleBlur}
                  ></textarea>
                  {errors?.business_address && touched?.business_address && (
                    <p className='mb-0 text-danger'>
                      {errors?.business_address + "*"}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {editCustomer && data1?.status !== "3" && (
          <div className='row'>
            <div className='d-flex justify-content-end'>
              <div>
                <button
                  type='button'
                  className={`btn btn-${
                    editing ? "warning" : "info"
                  } btn-sm mt-3 px-4 text-white`}
                  onClick={() => {
                    setEditing(editing ? false : true);
                    handleClose();
                  }}
                >
                  {editing ? "Close" : "Edit"}
                </button>
                {editing && (
                  <button className='btn btn-success ms-2 btn-sm mt-3 px-4'>
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default BusinessInformation;
